import { NavConfig } from '@pressreader/navigation-types';

import type { NavigateFailedPayload } from '../store';

/**
 * Check if navigation should be skipped based on multiple criteria
 */
export function shouldSkipNavigation(prevConfig: NavConfig | null, config: NavConfig): boolean {
    // If the cache key is the same, we skip navigation workflow
    if (prevConfig?.cacheKey && prevConfig.cacheKey === config.cacheKey) {
        return true;
    }

    return false;
}

// A view's un-cancelled load saga can finish AFTER a newer navigation replaced it (e.g. the
// article not-available redirect) and echo a `navigateDone`/`navigateFailed` for the superseded
// config; applying it would flip the rendered view back behind the current URL (#174564).
// Staleness is only judged when both ids are present — id-less configs pass through for
// orchestrations that don't mint route ids.
// Saga-side complement: `waitNavigationInProgressFinish` (store/sagas.utils.ts) awaits a navigation's
// terminal action by config-shape predicate; this helper id-checks a single action for supersession.
export function isStaleNavigation(config: NavConfig, currentNavId: string | null): boolean {
    return !!config.id && !!currentNavId && config.id !== currentNavId;
}

export function isNavigateFailedPayload(payload: unknown): payload is NavigateFailedPayload {
    return typeof payload === 'object' && payload !== null && 'config' in payload && (payload as NavigateFailedPayload).navigateFailed === true;
}
